module.exports = __webpack_public_path__ + "img/portfolio-details.ad25e9de.png";